'use strict';

// Note: Commenting based on requirement for RPP-4570
// ReEnable and rewrite based on RPP-3987

 const SELECTORS = {
    phoneField: '.js-phone-field',
}

/**
 * @description Initializes Phone Number format functionality
 */
// Note: Phone formatting removed as requeste by RPP-4570
// Leaving commented in case we want it back
// function initEvents() {
//     $(SELECTORS.phoneField).on('input', handlePhoneFormat);
// }

// function handlePhoneFormat() {
//     let $phoneField = $(this);

//     phoneFormat($phoneField[0]);
// }


// Note: Commenting based on requirement for RPP-4570
// let previousPhone = '';
// function phoneFormat(field) {
//     const specialCharCount = (field.value.match(/\D/g) || []).length;
//     let cursorPosition = field.selectionStart;

//     let input = field.value.replace(/\D/g,'');
//     const size = input.length;
//     if (input.substring(0, 1) == 1) {
//         if (size === 0) {
//             input=``;
//         } else if (size < 2) {
//             input=`+${input} `;
//         } else if (size < 4) {
//             input=`+${input.substring(0, 1)} (${input.substring(1)}`;
//         } else if (size < 8) {
//             input=`+${input.substring(0, 1)} (${input.substring(1, 4)}) ${input.substring(4)}`;
//         } else if (size < 12) {
//             input=`+${input.substring(0, 1)} (${input.substring(1, 4)}) ${input.substring(4, 7)}-${input.substring(7, 11)}`;
//         }
//     } else {
//         if (size > 7 && size < 11) {
//             input=`(${input.substring(0,3)}) ${input.substring(3,6)}-${input.substring(6)}`;
//         } else if (size > 3 && size < 8) {
//             input=`${input.substring(0,3)}-${input.substring(3)}`;
//         }
//     }

//     if (input !== previousPhone) {
//         previousPhone = input;
//         const specialCharDiff = (input.match(/\D/g) || []).length - specialCharCount;
//         cursorPosition += specialCharDiff;

//         field.value = input;
//         field.selectionStart = cursorPosition;
//         field.selectionEnd = cursorPosition;
//     }
// }

//exports.init = function () {
//    initEvents();// eslint-disable-line
//}

//RPP-3987
/**
 * Formats a phone number as XXX-XXX-XXXXXXXXX (up to 15 digits total)
 */
function formatPhoneNumber(input) {
    const cleaned = input.replace(/\D/g, '').substring(0, 15);
    const part1 = cleaned.substring(0, 3);
    const part2 = cleaned.substring(3, 6);
    const part3 = cleaned.substring(6); // rest (0–9 digits)

    if (part2 && part3) {
        return `${part1}-${part2}-${part3}`;
    } else if (part2) {
        return `${part1}-${part2}`;
    } else {
        return part1;
    }
}

/**
 * Initializes real-time phone formatting
 */
function initPhoneFormatting() {
    const $inputs = $(SELECTORS.phoneField);

    // Format phone values on page load
    $inputs.each(function () {
        const formatted = formatPhoneNumber(this.value);
        this.value = formatted;
    });

    // Re-format on input while typing
    $inputs.on('input', function () {
        const input = this;
        const cursorPos = input.selectionStart;
        const originalValue = input.value;

        const formatted = formatPhoneNumber(originalValue);
        input.value = formatted;

        // Adjust cursor position
        const adjustment = formatted.length - originalValue.length;
        const newCursorPos = cursorPos + adjustment;
        input.setSelectionRange(newCursorPos, newCursorPos);
    });
}

module.exports = function () {
    if ($('.js-phone-field').length > 0) {
        //alert("initPhoneFormatting");
        initPhoneFormatting();
    }
};

